export default __webpack_public_path__ + "static/media/hinh3.572f82b4.jpg";